import React from 'react';
import { useLoader } from '@/context/LoaderContext';
import Loader from '../Loader/Loader';

const GlobalLoader = () => {
  const { isLoading, loadingMessage } = useLoader();

  if (!isLoading) return null;

  return (
    <div className="fixed inset-0 bg-[#E6F2EF]/80 backdrop-blur-sm flex flex-col items-center justify-center z-[9999] pointer-events-auto">
      <div className="w-16 h-16 animate-spin mb-4">
        <svg width="100%" height="100%" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <mask id="mask0_1806_14279" style={{maskType:'luminance'}} maskUnits="userSpaceOnUse" x="0" y="7" width="13" height="13">
            <path d="M0.398926 7.75171H12.5801V19.9329H0.398926V7.75171Z" fill="white"/>
          </mask>
          <g mask="url(#mask0_1806_14279)">
            <mask id="mask1_1806_14279" style={{maskType:'luminance'}} maskUnits="userSpaceOnUse" x="-2" y="2" width="20" height="20">
              <path d="M-1.5238 9.66369L6.71018 2.05261L17.9851 14.2511L9.75115 21.8622L-1.5238 9.66369Z" fill="white"/>
            </mask>
            <g mask="url(#mask1_1806_14279)">
              <mask id="mask2_1806_14279" style={{maskType:'luminance'}} maskUnits="userSpaceOnUse" x="-2" y="2" width="20" height="20">
                <path d="M-1.5238 9.66369L6.71018 2.05261L17.9851 14.2511L9.75115 21.8622L-1.5238 9.66369Z" fill="white"/>
              </mask>
              <g mask="url(#mask2_1806_14279)">
                <path d="M12.4331 8.30315L2.45371 7.8576C0.524442 7.77325 0.200015 11.528 2.48399 11.5907L8.69354 11.7572L8.21987 18.0057C8.07496 19.909 11.7864 20.1102 11.8924 18.1766L12.4331 8.30315Z" fill="#18CB96"/>
              </g>
            </g>
          </g>
          <mask id="mask3_1806_14279" style={{maskType:'luminance'}} maskUnits="userSpaceOnUse" x="6" y="0" width="16" height="16">
            <path d="M6.4895 0H21.4391V15.5033H6.4895V0Z" fill="white"/>
          </mask>
          <g mask="url(#mask3_1806_14279)">
            <mask id="mask4_1806_14279" style={{maskType:'luminance'}} maskUnits="userSpaceOnUse" x="3" y="-7" width="26" height="26">
              <path d="M3.55457 2.61491L13.9233 -6.96869L28.2976 8.58438L17.9289 18.168L3.55457 2.61491Z" fill="white"/>
            </mask>
            <g mask="url(#mask4_1806_14279)">
              <mask id="mask5_1806_14279" style={{maskType:'luminance'}} maskUnits="userSpaceOnUse" x="3" y="-7" width="26" height="26">
                <path d="M3.55457 2.61491L13.9233 -6.96869L28.2976 8.58438L17.9289 18.168L3.55457 2.61491Z" fill="white"/>
              </mask>
              <g mask="url(#mask5_1806_14279)">
                <path d="M21.1169 0.901947L8.55725 0.343931C6.1327 0.235788 5.72175 4.95946 8.59619 5.03948L16.4106 5.24928L15.8136 13.1134C15.6319 15.5077 20.3037 15.7607 20.4356 13.3275L21.1169 0.901947Z" fill="#18CB96"/>
              </g>
            </g>
          </g>
        </svg>
      </div>
      {loadingMessage && (
        <p className="text-gray-700 font-medium text-center max-w-xs px-4">
          {loadingMessage}
        </p>
      )}
    </div>
  );
};

export default GlobalLoader; 